import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type User = {
  id: string;
  email: string;
  name?: string;
  phone?: string;
  role: 'admin' | 'customer';
  created_at: string;
  updated_at: string;
};

export type Artwork = {
  id: string;
  title: string;
  slug: string;
  description?: string;
  short_description?: string;
  price: number;
  currency: string;
  is_product: boolean;
  status: 'draft' | 'published';
  owner_id?: string;
  featured: boolean;
  category?: string;
  tags?: string[];
  formats?: string[];
  license_type?: string;
  sku?: string;
  primary_image?: string;
  gallery_images?: string[];
  seo_title?: string;
  seo_description?: string;
  og_image?: string;
  download_limit?: number;
  link_expiry: number;
  watermark_enabled: boolean;
  release_date?: string;
  created_at: string;
  updated_at: string;
};

export type Order = {
  id: string;
  user_id: string;
  total: number;
  status: 'pending' | 'completed' | 'failed' | 'refunded';
  payment_provider?: string;
  payment_provider_id?: string;
  created_at: string;
};

export type OrderItem = {
  id: string;
  order_id: string;
  artwork_id: string;
  price: number;
  license?: string;
  download_count: number;
  created_at: string;
};
